import React from "react";

/**
 * Global Error Boundary — catches unhandled React errors and shows
 * a fallback UI instead of a white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Log to console in development
    console.error("[ErrorBoundary] Uncaught error:", error, errorInfo);
  }

  handleReload = () => {
    // FIX 23.04.2026: `/` prowadzi do LandingPage a nie do /dashboard.
    // Dla zalogowanych uzytkownikow to wygladalo jak wylogowanie (sesja
    // byla zachowana, ale widzieli publiczna strone).
    window.location.href = "/dashboard";
  };

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-background p-6">
          <div className="max-w-md w-full text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-destructive"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            <div>
              <h1 className="text-2xl font-bold text-foreground mb-2">
                Wystąpił nieoczekiwany błąd
              </h1>
              <p className="text-muted-foreground">
                Aplikacja napotkała problem. Spróbuj odświeżyć stronę lub wrócić
                do strony głównej.
              </p>
            </div>

            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className="text-left bg-muted rounded-lg p-4 text-sm">
                <summary className="cursor-pointer font-medium text-foreground mb-2">
                  Szczegóły błędu (dev)
                </summary>
                <pre className="whitespace-pre-wrap text-destructive text-xs overflow-auto max-h-48">
                  {this.state.error.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
            )}

            <div className="flex gap-3 justify-center">
              <button
                onClick={this.handleRetry}
                className="px-4 py-2 rounded-md border border-border text-foreground hover:bg-accent transition-colors"
              >
                Spróbuj ponownie
              </button>
              <button
                onClick={this.handleReload}
                className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors"
              >
                Strona główna
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
